import QRCode from 'react-qr-code'
import { Dialog, DialogHeader, DialogBody, DialogFooter, Button, Typography } from '@material-tailwind/react'
import { FiMaximize2 } from 'react-icons/fi'

export const InviteSuccess = ({ sentInvites, onBack, qrOpen, qrTarget, openQr, closeQr }) => (
  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
    <div className="flex items-start justify-between gap-4">
      <div>
        <Typography className="text-green-800 font-medium">Invitaciones enviadas.</Typography>
        <Typography variant="small" className="text-green-700">
          Cada persona recibirá un correo con el enlace al formulario. También puedes mostrarles estos QR para que accedan al instante.
        </Typography>
      </div>
      <Button variant="text" onClick={onBack} className="flex items-center gap-2">
        <FiMaximize2 />
        Volver al formulario
      </Button>
    </div>

    {sentInvites.length > 0 && (
      <div className="mt-4 border-t border-green-200 pt-4">
        <Typography className="font-semibold mb-2">Accesos rápidos</Typography>
        <ul className="divide-y divide-gray-200">
          {sentInvites.map((inv, idx) => (
            <li key={idx} className="py-3 flex items-center justify-between gap-4">
              <div className="min-w-0">
                <p className="font-medium text-gray-900 truncate">{inv.name}</p>
                <p className="text-sm text-gray-600 truncate">{inv.email}</p>
              </div>
              <div className="shrink-0 flex items-center gap-2">
                <Button variant="outlined" size="sm" onClick={() => openQr(inv)} className="flex items-center gap-2">
                  <FiMaximize2 className="inline-block" />
                  Ver QR
                </Button>
                <Button variant="text" size="sm" onClick={() => window.open(inv.url, '_blank')}>Abrir enlace</Button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    )}

    <Dialog open={qrOpen} handler={closeQr} size="sm">
      <DialogHeader>{qrTarget?.name ? `QR para ${qrTarget.name}` : 'QR de invitación'}</DialogHeader>
      <DialogBody divider>
        {qrTarget?.url ? (
          <div className="w-full flex flex-col items-center gap-4">
            <div className="bg-white p-4 rounded">
              <QRCode value={qrTarget.url} size={192} viewBox="0 0 256 256" />
            </div>
            <Typography variant="small" className="text-gray-700 break-all text-center">
              {qrTarget.url}
            </Typography>
          </div>
        ) : (
          <Typography>Cargando…</Typography>
        )}
      </DialogBody>
      <DialogFooter>
        <Button variant="text" onClick={closeQr}>Cerrar</Button>
      </DialogFooter>
    </Dialog>
  </div>
)